import { Component, inject, signal } from '@angular/core';
import { IPageHeaderEntity } from '@web-nx-ng-tsc/web-shared-data-access';
import { LibPageHeaderComponent, LibTermsAndConditionComponent } from '@web-nx-ng-tsc/web-promo-shared-ui';
import { ActivatedRoute, Router } from '@angular/router';
import { IMeta, MetaService } from '@web-nx-ng-tsc/util-meta';

@Component({
  selector: 'app-term-and-condition',
  standalone: true,
  imports: [LibPageHeaderComponent, LibTermsAndConditionComponent],
  templateUrl: './term-and-condition.component.html',
  styleUrl: './term-and-condition.component.scss',
})
export class TermAndConditionComponent {
  // Inject
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly metaService = inject(MetaService);

  pageHeaderObj = signal<IPageHeaderEntity>({
    pageTitle: 'ข้อกำหนดและเงื่อนไข',
    pageSubTitle: '(Term & Condition)',
    subTitles: [
      {
        title: 'หน้าแรก',
        partName: '/',
      },
      {
        title: 'ข้อกำหนดและเงื่อนไข (Term & Condition)',
        partName: '',
      },
    ],
  });

  termsAndConditionObj = [
    {
      title: 'ขอบเขตการใช้งานเว็บไซต์',
      subtitle: [
        {
          headers:
            'เว็บไซต์นี้จัดทำโดย บริษัท ต.สยามคอมเมอร์เชียล จำกัด("บริษัท") เพื่อให้ข้อมูลเกี่ยวกับผลิตภัณฑ์, ข่าวสาร, และบริการของเรา',
        },
        {
          headers:
            'การใช้เว็บไซต์นี้ถือว่าคุณยอมรับข้อกำหนดและเงื่อนไขที่ระบุไว้ หากคุณไม่ยอมรับ โปรดหยุดการใช้งานเว็บไซต์ทันที',
        },
      ],
    },
    {
      title: 'ลิขสิทธิ์และทรัพย์สินทางปัญญา',
      subtitle: [
        {
          headers:
            'เนื้อหา ข้อความ รูปภาพ วิดีโอ และองค์ประกอบอื่นๆ บนเว็บไซต์นี้เป็นทรัพย์สินของบริษัท ห้ามทำซ้ำ ดัดแปลง หรือแจกจ่าย โดยไม่ได้รับอนุญาตเป็นลายลักษณ์อักษรจากบริษัท',
        },
        {
          headers:
            'เครื่องหมายการค้า ชื่อแบรนด์ และโลโก้ต่าง ๆ ที่ปรากฏบนเว็บไซต์เป็นกรรมสิทธิ์ของบริษัทหรือผู้อนุญาตให้ใช้สิทธิ ห้ามนำไปใช้โดยไม่ได้รับอนุญาต',
        },
      ],
    },
    {
      title: 'การใช้งานเว็บไซต์อย่างเหมาะสม',
      subtitle: [
        {
          headers: 'ห้ามใช้เว็บไซต์นี้ในลักษณะที่ก่อให้เกิดความเสียหาย, การรบกวน, หรือการกระทำใดๆ ที่ผิดกฎหมาย',
        },
        {
          headers: 'ห้ามทำการอัปโหลดหรือส่งข้อมูลที่เป็นอันตราย เช่น ไวรัส มัลแวร์ หรือสแปม',
        },
      ],
    },
    {
      title: 'ข้อจำกัดความรับผิดชอบ',
      subtitle: [
        {
          headers: 'บริษัทไม่รับประกันว่าเว็บไซต์จะไม่มีข้อผิดพลาด หรือไม่มีการหยุดชะงัก',
        },
        {
          headers:
            'บริษัทจะไม่รับผิดชอบต่อความเสียหายหรือความสูญเสียใด ๆ ที่เกิดขึ้นจากการใช้งานเว็บไซต์ รวมถึงความสูญเสียทางการเงินหรือข้อมูลส่วนบุคคล',
        },
      ],
    },
    {
      title: 'การเปลี่ยนแปลงข้อกำหนด',
      subtitle: [
        {
          headers: 'บริษัทขอสงวนสิทธิ์ในการปรับเปลี่ยนข้อกำหนดและเงื่อนไขได้ตลอดเวลา โดยไม่ต้องแจ้งให้ทราบล่วงหน้า',
        },
        {
          headers: 'การเปลี่ยนแปลงจะมีผลทันทีเมื่อประกาศบนเว็บไซต์',
        },
      ],
    },
    {
      title: 'การเชื่อมโยงไปยังเว็บไซต์บุคคลที่สาม',
      subtitle: [
        {
          headers:
            'เว็บไซต์อาจมีลิงก์ไปยังเว็บไซต์บุคคลที่สามเพื่อความสะดวก แต่บริษัทไม่รับผิดชอบต่อเนื้อหาหรือการใช้งานเว็บไซต์ดังกล่าว',
        },
      ],
    },
  ];

  constructor() {
    this.metaService.updateMeta(this.route.snapshot.data as IMeta);
    this.onSetOpenGraphTags();
  }

  redirectTo(url: string) {
    this.router.navigate([`${url}`]);
  }

  onSetOpenGraphTags() {
    this.metaService.updateOpenGraph({
      title: 'ข้อกำหนดและเงื่อนไขการใช้บริการ | TOYO TIRES Thailand',
      description:
        'เอกสารข้อกำหนดและเงื่อนไขการใช้เว็บไซต์/บริการของ TOYO TIRES ครอบคลุมขอบเขตการใช้งาน สิทธิและหน้าที่ของผู้ใช้ หลักเกณฑ์ทางกฎหมาย ข้อจำกัดความรับผิด และแนวทางการติดต่อ สร้างความโปร่งใสและความมั่นใจในการใช้งานทุกส่วนของเว็บไซต์ | TOYO TIRES Thailand',
      image: 'https://tsc-pub-blob.s3.ap-southeast-7.amazonaws.com/2025-08/logo-toyo_result-20250819114158.webp',
    });
  }
}
